import gsap, {Linear} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
// import {debounce} from 'throttle-debounce';
import initScrollTrigger from '../helpers/initScrollTrigger';

import accordeon from '../helpers/accordeon';

import {getSimplePlayer, initScrollAutoplayVideo} from '../components/video';
import { initLines } from './line-ticker';

import сustomPageScroll from './custom-scroll';

import {IS_PHONE, BREAKPOINTS, CLASSES} from '../helpers/consts';
import isPortrait from '../helpers/isPortrait';
import refreshScrollAndTriggers from '../helpers/refreshScrollTriggers';

gsap.registerPlugin(ScrollTrigger);


const getMaxHeight = (elements) => {
	let maxHeight = 0;

	for (let i = 0; i < elements.length; i++) {
		const elementHeight = elements[i].offsetHeight;
		maxHeight = Math.max(maxHeight, elementHeight);
	}
	return maxHeight;
};


const initMobAccordeon = () => {
	const section = document.querySelector('.js-team-section');
	if(!section) return;

	const lines = section.querySelectorAll('.js-team-line-container');
	const accordElems = [...section.querySelectorAll('.js-team-section-fixed-item')];
	const dropBlocks = section.querySelectorAll('.js-team-section-main');

	const players = [];
	dropBlocks.forEach((block) => {
		const video = block.querySelector('.js-team-section-mob-media-wrapper .js-about-team-video');
		if(video) {
			players.push(false);
		}
		else {
			players.push(null);
		}
	});

	setTimeout(() => {
		initLines(lines);
	}, 2000);

	accordeon({
		needCloseOther: false,
		duration: 0.5,
		ease: 'power1.out',
		delay: 0,
		onStart: () => {},
		onComplete: (el) => {
			const isOpen = el.classList.contains(CLASSES.open);
			const index = accordElems.indexOf(el);

			if(isOpen) {
				if(players[index] === false) {
					const video = el.querySelector('.js-team-section-mob-media-wrapper .js-about-team-video');
					const player = getSimplePlayer(video, {
						muted: true,
						ratio: '9:16',
						controls: [],
					});
					player.on('ready', () => {
						player.volume = 0;
						player.play();
					});
					players[index] = player;
				}
				else {
					if(players[index]) players[index].play();
				}

			}
			else {
				if(players[index]) players[index].pause();
			}
			refreshScrollAndTriggers();
		}
	});
};

const initScrollSection = () => {

	initScrollTrigger();

	const section = document.querySelector('.js-team-section');
	if(!section) return;
	const globalBg = document.querySelector('.js-about-dinamic-bg');
	// const bottomGradientEl = document.querySelector('.js-about-dinamic-gradient');
	const wrapper = section.querySelector('.js-team-section-inner');
	const fixedBlock = section.querySelector('.js-team-section-fixed-block');
	const fixedItems = section.querySelectorAll('.js-team-section-fixed-item');
	const mediaBlocks = section.querySelectorAll('.js-team-section-media-block');
	const mediaVideos = [...section.querySelectorAll('.js-team-section-media-block .js-about-team-video')];
	let lastBlockColor = '';

	initScrollAutoplayVideo(mediaVideos, {
		ratio: '9:16',
		muted: true,
		controls: [],
		autoplay: false,
	});

	const trigger = ScrollTrigger.create({
		trigger: wrapper,
		scrub: 0.5,
		pin: fixedBlock,
		// pinSpacing: true,
		start: 'top top',
		end: () => {
			if(isPortrait()) {
				const blockH = wrapper.getBoundingClientRect().height;
				const maxElemsHeight = getMaxHeight(fixedItems);

				return `${blockH + maxElemsHeight} bottom`;
			}
			return 'bottom bottom';
		},
	});

	const changeFixedItems = (activeItem) => {
		fixedItems.forEach((item) => {
			item.classList.remove(CLASSES.active);
		});
		activeItem.classList.add(CLASSES.active);
	};

	const pinkColor = 'is-global-pink-color';
	const pinkBlueColor = 'is-global-pink-blue-color';
	const brownColor = 'is-global-brown-color';
	const blueColor = 'is-global-blue-color';
	
	const clearGlobalColors = () => {
		document.body.classList.remove(brownColor);
		document.body.classList.remove(pinkColor);
		document.body.classList.remove(blueColor);
		document.body.classList.remove(pinkBlueColor);
	}
	
	const changeHeaderClassFromSliderColor = (color) => {
		clearGlobalColors();
		if( color === '#ECD8FF') {
			document.body.classList.add(brownColor);
		} else if ( color === '#7F526F') {
			document.body.classList.add(pinkColor);
		} else if ( color === '#BBD8FF') {
			document.body.classList.add(blueColor);
		} else if ( color === '#382F68') {
			document.body.classList.add(pinkBlueColor);
		}
	}

	mediaBlocks.forEach((mediaBlock, i) => {
		const fixItem = fixedItems[i];

		const blockColor = getComputedStyle(fixItem).getPropertyValue('--bg-color');
		const prevBgColor =  i > 0 ? getComputedStyle(fixedItems[i - 1]).getPropertyValue('--bg-color'): false;

		if(i === mediaBlocks.length - 1) {
			lastBlockColor = blockColor;
			// bottomGradientEl.style.setProperty('--bottom-gradient-color', blockColor);
		}

		const trigger = ScrollTrigger.create({
			trigger: mediaBlock,
			start: 'top 50%',
			end: 'bottom bottom',
			onEnter: () => {
				globalBg.style.setProperty('--bg-section-color', blockColor);
				globalBg.classList.add('is-changed-color');
				changeHeaderClassFromSliderColor(blockColor);
				
				changeFixedItems(fixItem);

			},
			// onLeave: () => {
			// 	if(i === mediaBlocks.length - 1) {
			// 		console.log(111)
			// 		// bottomGradientEl.style.setProperty('--bottom-gradient-color', blockColor);
			// 	}
			// },
			onLeaveBack: () => {
				if(prevBgColor) {
					globalBg.style.setProperty('--bg-section-color', prevBgColor);
					changeHeaderClassFromSliderColor(prevBgColor);
				}
				else {
					globalBg.classList.remove('is-changed-color');
					globalBg.style.setProperty('--bg-section-color', 'transparent');
					changeHeaderClassFromSliderColor('transparent');
				}
				if(i === 0) {
					changeFixedItems(fixedItems[0]);
				}
				else {
					changeFixedItems(fixedItems[i - 1]);
				}
			},
		});
	});

	const sectionTrigger = ScrollTrigger.create({
		trigger: section,
		start: 'top top',
		end: () => {
			return isPortrait() ? 'bottom 60%' : 'bottom 80%';
		},
		onEnterBack: () => {
			globalBg.style.setProperty('--bg-section-color', lastBlockColor);
			changeHeaderClassFromSliderColor(lastBlockColor);
		},
		onLeave: () => {
			globalBg.style.setProperty('--bg-section-color', '#ECD8FF');
			// changeHeaderClassFromSliderColor('#ECD8FF');
			clearGlobalColors();
		},
	});

};
export default () => {

	if(!IS_PHONE) {
		initScrollSection();
	}
	else {
		initMobAccordeon();
	}
};
